import { render, staticRenderFns } from "./FacilityEditAddresses.vue?vue&type=template&id=5109579c&"
import script from "./FacilityEditAddresses.vue?vue&type=script&lang=js&"
export * from "./FacilityEditAddresses.vue?vue&type=script&lang=js&"
import style0 from "./FacilityEditAddresses.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports